mtl.alloy.factory['facebook-share'] = (function($) {
	'use strict';

	return function(element, options) {

		var $element = $(element);
		var $href = (typeof $element.data('href') !== 'undefined') ? $element.data('href') : window.location.href;

		$element.on('click', function(){
			FB.ui({
			  method: 'share',
			  href: $href
			}, function(response){});
		});

	};

}($));
